<template>
  <div style="padding: 0px 10px;">
    <!-- <el-row class="el-row elrow" v-if="selectRadioType==0">
      <el-col :span="20">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item @click.native="onBreadcrumb(null)">首页</el-breadcrumb-item>
          <el-breadcrumb-item
            @click.native="onBreadcrumb(item.ID)"
            v-for="item in taskGropuParent"
            :key="item.ID"
          >{{item.TASKNAME}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="selectFolderType" size="small" class="topCard">
          <el-radio-button label="0">
            <i class="iconfont icon-liebiao"></i>
          </el-radio-button>
          <el-radio-button label="1">
            <i class="iconfont icon-weibiaoti5"></i>
          </el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>-->
    <div>
      <TaskFolderList :isShowButton="isShowButton" :tableHeight="tableHeight" :isGroup="isGroup" :isTemplate="isTemplate" ref="TaskFolderList" v-show="selectFolderType==0" @changeCurTask="changeCurTask"></TaskFolderList>
      <TaskGroupList :isShowButton="isShowButton" :tableHeight="tableHeight" :isTemplate="isTemplate"
        v-show="selectRadioType == 0 && selectFolderType==1"
        @changeCurTask="changeCurTask"
      ></TaskGroupList>
    </div>
    <div class="el-row" v-if="isPagination">
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="[10, 30, 50, 100]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>-->
      <div class="el-row">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @prev-click="handleCurrentChange"
          @next-click="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 30, 50, 100]"
          layout="total, sizes,prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination> -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" :page-sizes="[10, 30, 50, 100]" :layout="pageLayout"
			    :total="totalCount">
           <el-select v-model="$store.state.task.pageSize" size="mini" @change="pageSizeChange" >
            <el-option
              v-for="item in pageSizes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
			</el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "@/components/common/icon.vue";
import TaskGroupList from "./taskFolder";
import TaskFolderList from "./taskFolderList";
import TaskGroupWorkRecord from "@/views/task/components/TaskGroupWorkRecord";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "taskGroup",
  components: {
    icon,
    TaskGroupList,
    TaskGroupWorkRecord,
    TaskFolderList
  },
  data() {
    return {
      listHeight: "200px", // 列表的高度
      curTask: null,
      pageLayout:'total, slot,prev, pager, next, jumper',
        pageSizes:[{label:'10条/页',value:10},{label:'30条/页',value:30},{label:'50条/页',value:50},{label:'100条/页',value:100},{label:'全部',value:20}],
    };
  },
  props:{
    isPagination:{
      type:Boolean,
      default:true
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    isTemplate:{//是否是模板
      type: Boolean,
      default:false,
    },
    isShowButton:{//是否显示按钮，不显示按钮不需要触发dispatch("changeCurTask"）
      type: Boolean,
      default:true,
    },
    tableHeight:Number
  },
  computed: {
    ...mapState({
      selectRadioType: state => state.task.selectRadioType,
      taskGropuParent: state => state.task.taskGropuParent,
      pageSize: state => state.task.pageSize,
      totalCount: state => state.task.totalCount,
      selectFolderType: state => state.folder.selectFolderType
    }),
    pageIndex: {
      get: function() {
        return this.$store.state.task.pageIndex;
      },
      set: function(val) {
        this.$store.commit('changePageIndex', val);
      }
    }
  },
  methods: {
    clearSelection() {
      this.$refs.TaskFolderList.clearSelection();
    },
    deleteResult(data) {
      this.$refs.TaskFolderList.deleteResult(data);
    },
    pageSizeChange(size){
        if(size==20){
          this.$store.state.task.isInfiniteScroll=true;
          this.pageLayout='total, slot'
        }else{
          this.$store.state.task.isInfiniteScroll=false;
          this.pageLayout='total, slot,prev, pager, next, jumper'
        }
        this.$store.dispatch('changePageSize', {size:size,type:this.$store.state.task.type});
      },
    onBreadcrumb(id) {
      this.$store.commit("setTaskGroupCurrents", id);
    },
    changeCurTask(row) {
      this.curTask = row;
      console.log("1", row);
      this.$emit("changeCurTask", row);
    },
    // handleSizeChange(val) {
    //   this.$store.state.task.taskGroupParas.PageSize = val;
    //   this.$store.dispatch("GetTaskGroupTaskList");
    // },
    // handleCurrentChange(val) {
    //   this.$store.state.task.taskGroupParas.PageIndex = val;
    //   this.$store.dispatch("GetTaskGroupTaskList");
    // },
    handleSizeChange(val) {
      this.$store.dispatch("changePageSize", {
        size: val,
        type: this.$store.state.task.type
      });
    },
    handleCurrentChange(val) {
      this.$store.dispatch("changePageIndex", {
        index: val,
        type: this.$store.state.task.type
      });
    }
  }
};
</script>

<style lang="less" scoped>
.basePanel {
  height: 100%;
}
h3 {
  float: left;
  line-height: 0;
  margin-left: 21px;
  margin-top: 25px;
  color: #424242;
}
.topCard {
  float: right; // margin-bottom: 7px;
  // margin-right: 16px;
}
.breadcrumb {
  font-size: 16px;
  padding: 8px;
}
.elrow {
  background: white;
}
.el-row {
  margin-top: 5px;
  background: white;
}
.basePanel_div {
  position: static;
}
</style>
